import React, { useState } from 'react';
import audioLogo from './styles/audio.png';
import './styles/tts.css';

const getAudio = async (word, languageCode) => {
  console.log(word);

  const genders = ['MALE', 'FEMALE', 'NEUTRAL'];

  try {
    const response = await fetch("http://localhost:3001/tts", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        text: word,
        languageCode: languageCode,
        gender: genders[Math.floor(Math.random() * genders.length)],
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch audio");
    }

    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (err) {
    console.error("Error fetching audio:", err);
    return null;
  }
};

const getAudioFromFlask = async (word) => {
  try {
    const response = await fetch("https://yorubadictionary.yale.edu/api/play_word_2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        word: word
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch audio");
    }

    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (err) {
    console.error("Error fetching audio:", err);
    return null;
  }
}

const TTSButton = ({word, buttonText, languageCode}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    
    try {
      console.log(word);
      const audio = await getAudioFromFlask(word);
      if (audio) {
        const audioObj = new Audio(audio);
        audioObj.currentTime = 0;
        audioObj.play();
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <span className="tts-button-container" style={{ marginLeft: '15px'}}>
      {isLoading ? 'Loading...' : 
        <img className="Audio-icon" 
          src={audioLogo} 
          onClick={handleClick} 
          style={{ verticalAlign: 'middle', cursor: 'pointer' }} />
      }              
    </span>
  );
};

export default TTSButton;
